<template>
  <div id="ManifestImportFilters">
    <v-expansion-panels class="px-5 py-1" accordion>
      <v-expansion-panel class="elevation-1">
        <v-expansion-panel-header color="#f2f2f2" class="px-4">
          <span>Filtrar por</span>
          <template v-slot:actions>
            <v-icon color="black">mdi-chevron-down</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2 pb-1">
            <v-col cols="12" md="4">
              <v-menu
                ref="menuDateStart"
                v-model="menuDateStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedStartDate"
                    label="Data Importação Início"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  :max="getMaxDateForInitial()"
                  :active-picker.sync="activePicker"
                  locale="pt-br"
                  @change="saveInitial"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                ref="menuDateEnd"
                v-model="menuDateEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedEndDate"
                    label="Data Importação Fim"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endDate"
                  :active-picker.sync="activePicker"
                  :min="getMinDateForEnd()"
                  :max="getTodayDate()"
                  locale="pt-br"
                  @change="saveEnd"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="numberProcess"
                label="Número do processo"
                @change="saveNumberProcess"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="responsibleSelected"
                :items="users"
                label="Usuário responsável / Importado por"
                item-text="name"
                item-value="userId"
                @change="saveResponsible"
                    clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="stepSelected"
                :items="stepsManualBoarding"
                label="Etapa da importação"
                item-text="name"
                item-value="id"
                @change="saveStepId"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="12" class="d-flex justify-end align-center">
              <v-btn
                :disabled="!hasFilters"
                elevation="2"
                color="red"
                class="mx-2"
                :dark="hasFilters"
                @click="cleanFilter"
              >
                Limpar Filtros
              </v-btn>
              <v-btn
                :loading="loading || loadingGetAll"
                :disabled="!hasFilters"
                :dark="hasFilters"
                elevation="2"
                color="green"
                @click="search"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
export default {
  name: 'ManualBoardingFilters',
  props: {
    loadingGetAll: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    loading: false,
    menuDateStart: false,
    menuDateEnd: false,
    startDate: null,
    endDate: null,
    numberProcess: [],
    nfeProcessInput: '',
    activePicker: null,
    responsibleSelected: null,
    stepSelected: null,
    stepsManualBoarding: [],
    users: []
  }),
  mounted() {
    this.fetchAllStepsBoarding();
    this.fetchAllUsers();
    this.filterTheLastThirtyDays();
  },
  computed: {
    hasFilters() {
      if (this.startDate || this.endDate || this.responsibleSelected || this.stepSelected || this.numberProcess) {
        return true;
      }
      return false;
    },
    formattedStartDate() {
      return this.startDate ? this.formatDateToDisplay(this.startDate) : '';
    },
    formattedEndDate() {
      return this.endDate ? this.formatDateToDisplay(this.endDate) : '';
    }
  },
  methods: {
    ...mapMutations('ManualBoardingStore', [
      'setItemPerPage',
      'setPageNumber',
      'setFilterResponsibleUserId',
      'setFilterCreatedAtStart',
      'setFilterCreatedAtEnd',
      'setFilterNumberProcess',
      'setFilterStepId'
    ]),
    ...mapActions('ManualBoardingStore', ['fetchSummarySteps']),
    ...mapActions('UserStore', ['fetchListUsers']),

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays();
      this.startDate = thirtyDayAgo;
      this.endDate = currentDay;
      this.saveInitial();
      this.saveEnd();
    },
    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);
      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    },
    search() {
      this.$emit('filterSearch');
    },
    async fetchAllStepsBoarding() {
      this.loading = true;
      try {
        const data = await this.fetchSummarySteps();
        this.stepsManualBoarding = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllUsers() {
      this.loading = true;
      try {
        const data = await this.fetchListUsers();
        this.users = data.sort((a, b) => a.name.localeCompare(b.name));
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    getTodayDate() {
      const today = new Date();
      return this.formatDate(today);
    },
    getMaxDateForInitial() {
      return this.endDate ? this.formatDate(new Date(this.endDate)) : this.getTodayDate();
    },
    getMinDateForEnd() {
      return this.startDate ? this.formatDate(new Date(this.startDate)) : null;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatDateToDisplay(date) {
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    saveResponsible() {
      this.setFilterResponsibleUserId(this.responsibleSelected);
    },
    saveInitial() {
      this.setFilterCreatedAtStart(this.startDate);
    },
    saveEnd() {
      this.setFilterCreatedAtEnd(this.endDate);
    },
    saveNumberProcess() {
      this.setFilterNumberProcess(this.numberProcess);
    },
    saveStepId() {
      this.setFilterStepId(this.stepSelected);
    },
    cleanFilter() {
      this.setFilterCreatedAtStart(null);
      this.setFilterCreatedAtEnd(null);
      this.setFilterNumberProcess(null);
      this.setFilterResponsibleUserId(null);
      this.setFilterStepId(null);
      this.clearFilterFields();
      this.$emit('filterSearch');
    },
    clearFilterFields() {
      this.numberProcess = null;
      this.startDate = null;
      this.endDate = null;
      this.responsibleSelected = null;
      this.stepSelected = null;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
</style>
